import {
  UpdateContactInfoInput,
  UpdateContactInfoOutput,
} from "@redotech/redo-order-editing-common/schemas/update-contact-info";

export const updateContactInfoSelfServe = {
  name: "updateContactInfoSelfServe" as const,
  input: UpdateContactInfoInput,
  output: UpdateContactInfoOutput,
};
